import React from "react";
import { Container, Typography, Box, Button } from "@mui/material";
import GppBadOutlinedIcon from "@mui/icons-material/GppBadOutlined";

interface AccessDeniedProps {
    onLogout: () => void;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({ onLogout }) => {
    return (
        <Container>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                minHeight="100vh"
            >
                <GppBadOutlinedIcon sx={{ fontSize: 80, color: "error.main", mb: 2 }} />
                <Typography variant="h4" component="h1" gutterBottom>
                    Access Denied
                </Typography>
                <Typography variant="body1" align="center">
                    You are not authorized to access this page. Please contact your
                    administrator if you believe this is an error.
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onLogout}
                    sx={{ mt: 2 }}
                >
                    Logout
                </Button>
            </Box>
        </Container>
    );
};

export default AccessDenied; 